/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { getReviewHistoryV3ResponseDataSchema } from '../../progress/getReviewHistoryV3/get-review-history-v3-response';

export const getUserHistoryV1ResponseDataSchema = getReviewHistoryV3ResponseDataSchema;

export type IGetUserHistoryV1ResponseData = z.infer<typeof getUserHistoryV1ResponseDataSchema>;

export const getUserHistoryV1ResponseSchema = createApiResponseSchema(
  getUserHistoryV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetUserHistoryV1ResponseData>>;

export type IGetUserHistoryV1Response = IAPI<IGetUserHistoryV1ResponseData>;
